import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const oneSignal = defineConnector({
  identifier: "oneSignal",
  name: "OneSignal",
  tagLine: "Push notifications and messaging",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () => "https://api\\.onesignal\\.com/.*",
  auth: (app) =>
    headerAuth([
      { name: "Authorization", value: app.secret.apiKey, scheme: "Key" },
    ]),
  steps: [
    {
      title: "Get your app API key",
      items: [
        {
          kind: "markdown",
          content:
            "In the [OneSignal dashboard](https://dashboard.onesignal.com/), open your app’s **Settings › Keys & IDs** and copy the app ID and an app API key.",
        },
      ],
    },
    {
      title: "Enter your OneSignal details",
      items: [
        {
          kind: "input",
          label: "App ID",
          required: true,
          target: { kind: "configuration", field: "appId" },
        },
        {
          kind: "input",
          label: "App API key",
          placeholder: "os_v2_...",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ appId }) =>
      `https://api.onesignal.com/notifications?app_id=${appId}&limit=1`,
  },
});
